// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"f260a319","231":"f260a319","291":"82e57926","440":"0791c643","839":"f9cf8338","913":"dc13c8d9","978":"f260a319"}[chunkId] + ".chunk.css";
};